const getAllUrlParams = () => {
  const searchParams = new URLSearchParams(location.search);

  return Array.from(searchParams.entries()).reduce<Record<string, string>>(
    (o, [k, v]) => {
      o[k] = v;
      return o;
    },
    {}
  );
};

export { getAllUrlParams };
